<template>
    <div class="time-container">
    <span class="formatted-time">{{ formattedTime }}</span>
     <span 
      class="formatted-max" 
      v-if="formattedMax !== $t('orders.CollectionCompleted') &&  formattedMax !== $t('orders.NotCollectingYet')"
    >
     {{ `${$t('orders.Final')}: ${formattedMax}` }}

    </span>
  </div>
</template>

<script>
export default {
    props: {
        endTime: {
            type: String,
            required: true,
        },
        maxTime: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            formattedTime: this.getRemainingTime(this.endTime),
            formattedMax:this.getRemainingTime(this.maxTime),
            interval: null
        };
    },
    mounted() {
        this.interval = setInterval(() => {
            this.formattedTime = this.getRemainingTime(this.endTime);
            this.formattedMax = this.getRemainingTime(this.maxTime);
        }, 1000);
    },
    beforeUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        getRemainingTime(value) {
            if (!value) {
                return this.$t('orders.NotCollectingYet');
            }

            const now = new Date();
            const nowDate = Date.UTC(
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate(),
                now.getUTCHours(),
                now.getUTCMinutes(),
                now.getUTCSeconds()
            );

            const endTimeUTC = value.endsWith("Z")
                ? value
                : value + "Z";
            const endDate = new Date(endTimeUTC);
            const diffMs = endDate.getTime() - nowDate;

            if (diffMs < 0) {
                return this.$t("orders.CollectionCompleted");
            }

            let seconds = Math.floor(diffMs / 1000);
            const years = Math.floor(seconds / (365 * 24 * 60 * 60));
            seconds %= 365 * 24 * 60 * 60;

            const months = Math.floor(seconds / (30 * 24 * 60 * 60));
            seconds %= 30 * 24 * 60 * 60;

            const days = Math.floor(seconds / (24 * 60 * 60));
            seconds %= 24 * 60 * 60;

            const hours = Math.floor(seconds / (60 * 60));
            seconds %= 60 * 60;

            const minutes = Math.floor(seconds / 60);
            seconds %= 60;

            const parts = [];

            if (years > 0) parts.push(`${years}y`);
            if (months > 0) parts.push(`${months}m`);
            if (days > 0) parts.push(`${days}d`);
            if (hours > 0) parts.push(`${hours}h`);
            if (minutes > 0) parts.push(`${minutes}min`);
            if (seconds > 0) parts.push(`${seconds}s`);

            return parts.length > 0 ? parts.join(" ") : this.$t("orders.LessThanASec");
        },
    },
};
</script>
<style scoped>
.time-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.formatted-time {
  font-size: 1rem;
}

.formatted-max {
  font-size: 0.8rem;
  background-color: #d4edda; 
  color: #155724; 
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 2px;
  margin-left: 12px; 
}
</style>